import { render, staticRenderFns } from "./common-pup.vue?vue&type=template&id=036bb31b&scoped=true&"
import script from "./common-pup.vue?vue&type=script&lang=js&"
export * from "./common-pup.vue?vue&type=script&lang=js&"
import style0 from "./common-pup.vue?vue&type=style&index=0&id=036bb31b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036bb31b",
  null
  
)

export default component.exports